import * as Yup from "yup";

//este codigo crea un modelo y unas validaciones de datos para el formulario de creacion de menus

export function initialValues(menu) {
  return {
    title: menu?.title || "",
    path: menu?.path || "",
    protocol: "https://",
    active: menu?.active || true,
    order: menu?.order || 0,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required(true),
    path: Yup.string().required(true),
    order: Yup.number().required(true),
  });
}
